export default "__VITE_ASSET__CYs6ZVY7__"